import React from 'react';
import { Button } from '../ui/button';
import './LeaveConfirmationModal.scss';

interface LeaveConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LeaveConfirmationModal({
  isOpen,
  onConfirm,
  onCancel,
}: LeaveConfirmationModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="leave-modal-overlay" onClick={onCancel}>
      <div className="leave-modal" onClick={(e) => e.stopPropagation()}>
        <div className="leave-modal__icon">
          <svg
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>

        <h3 className="leave-modal__title">Leave Meeting?</h3>
        <p className="leave-modal__message">
          Are you sure you want to leave this consultation? The call will end for you.
        </p>

        <div className="leave-modal__actions">
          <Button
            variant="outline"
            onClick={onCancel}
            className="leave-modal__cancel-btn"
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            className="leave-modal__confirm-btn"
          >
            Leave Meeting
          </Button>
        </div>
      </div>
    </div>
  );
}
